import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-angle-collapse",
  "use": "arrow-angle-collapse-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-angle-collapse\"><path d=\"M8.568 10.702c-.208.208-.4.667 0 1.066.4.4.859.209 1.067 0l4.267-4.266-4.267-4.267c-.208-.208-.663-.404-1.067 0-.403.404-.208.858 0 1.067l3.2 3.2-3.2 3.2z\" /><path d=\"M3.235 10.702c-.208.208-.4.667 0 1.066.4.4.858.209 1.067 0l4.266-4.266-4.266-4.267c-.209-.208-.663-.404-1.067 0-.404.404-.208.858 0 1.067l3.2 3.2-3.2 3.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol